export default __webpack_public_path__ + "static/vikrant-e7e0717f1998751bc5d6d0282581d71d.jpg";